import moment from 'moment-timezone';
import React from 'react';
import DatePicker from 'react-datepicker';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router-dom";
import { Alert, Button, FormGroup, Input, InputGroup, InputGroupAddon, Label } from 'reactstrap';
import BinaryRadio from './BinaryRadio';
import CreateRecordEvent from './CreateRecordEvent';
import CreateRecordHolter from './CreateRecordHolter';
import CreateRecord12Lead from './CreateRecord12Lead';
import CreateRecordCrfQa from './CreateRecordCrfQa';
import ErrorBoundary from './ErrorBoundary';
import DropdownSelection from '../data/DropDown';
import MdOverreadAssigned from './MdOverreadAssigned';
import NotAuthenticated from './NotAuthenticated';
import * as Accounts from '../store/Accounts';
import * as elements from '../data/Elements';
import * as paths from '../data/Paths';
import * as Records from '../store/Records';
import * as utility from '../data/Utility';

const createRecordType = {
    deviceModel: "deviceModel",
    deviceSerial: "deviceSerial",
    isMdOverreadRequired: "isMdOverreadRequired",
    isQaRequired: "isQaRequired",
    isScheduled: "isScheduled",
    isSymptomatic: "isSymptomatic",
    mdOverreadAssignedId: "mdOverreadAssignedId",
    receiveDateTime: "receiveDateTime",
    recordDateTime: "recordDateTime",
    receiveDate: "receiveDate",
    receiveTime: "receiveTime",
    recordDate: "recordDate",
    recordTime: "recordTime",
    report: "report",
    serviceType: "serviceType",
    timeZoneOffsetMinutes: "timeZoneOffsetMinutes",
    comments: "comments",
    mdOverreadFindings: "mdOverreadFindings",
    mdRejectionReason: "mdRejectionReason",
    predominantRhythm: "predominantRhythm",
    hasAfib: "hasAfib",
    hasAflutter: "hasAflutter",
    hasAtachy: "hasAtachy",
	hasAfib30: "hasAfib30",
	hasAflutter30: "hasAflutter30",
	hasAtachy30: "hasAtachy30",
	hasAfibContinuous: "hasAfibContinuous",
	hasAflutterContinuous: "hasAflutterContinuous",
	hasAtachyContinuous: "hasAtachyContinuous",
	afibLongestDuration: "afibLongestDuration",
	aflutterLongestDuration: "aflutterLongestDuration",
	atachyLongestDuration: "atachyLongestDuration",
	isMdNotification: "isMdNotification",
	isAnalyzable: "isAnalyzable",
	totalDuration: "totalDuration",
	analyzableDuration: "analyzableDuration",
	showAfibChildren: false,
	showAflutterChildren: false,
	showAtachyChildren: false,
	showReAuthenticator: false,
}
const blankDropdown = '---';


class CreateRecordInternal extends React.Component {
    constructor(props) {
        super(props);

        const create = utility.propCheck(props.create, true);
        const editing = utility.propCheck(props.editing, true);
        const patientCode = utility.propCheck(props.patientCode, "");
        const patientId = utility.propCheck(props.patientId, "");
        const recordId = utility.propCheck(props.recordId, "");
        const serviceType = utility.propCheck(props.serviceType, Records.recordServiceTypes.twelveLead);
        const studyId = utility.propCheck(props.studyId, "");
		let currentSchedulePeriod = blankDropdown;
        var crfQnA = utility.propCheck(props.crfQnA, []);

		const allStudies = this.props.accountsState && this.props.accountsState.authenticatedAccount && this.props.accountsState.authenticatedAccount.studies;
		if ( allStudies ) {
			const thisStudyId = studyId;
			const study = allStudies.find( function (s) { return s.id === thisStudyId } );
			if ( study ) {
				let allCompSchedules = study.allCompSchedules;
				if ( allCompSchedules ) {
					if ( typeof allCompSchedules === 'string' || allCompSchedules instanceof String ) {
						allCompSchedules = JSON.parse(allCompSchedules);
					}
					if ( allCompSchedules ) {
						currentSchedulePeriod = allCompSchedules[serviceType];
					}
				}
			}
		}

        this.state = {
            create: create,
			crfQnA: crfQnA,
			currentSchedulePeriod: currentSchedulePeriod,
			currentScheduleOrdinal: blankDropdown,
			currentScheduleSuffix: blankDropdown,
            editing: editing,
            patientCode: patientCode,
            patientId: patientId,
            recordId: recordId,
            studyId: studyId,
			timeZoneOffsetMinutes: 0,
        };

        this.handleCancel = this.handleCancel.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleValue = this.handleValue.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);

		const recordStateRecord = this.props.recordsState.record;
		const serviceType = recordStateRecord && recordStateRecord.record && recordStateRecord.record.serviceType;

        if ( recordStateRecord ) {
			recordStateRecord.record.serviceType = serviceType;
			this.props.recordsDispatch.set(recordStateRecord);
		}

		const allStudies = this.props.accountsState && this.props.accountsState.authenticatedAccount && this.props.accountsState.authenticatedAccount.studies;
		if ( allStudies && serviceType ) {
			const thisStudyId = this.state.studyId;
			const study = allStudies.find( function (s) { return s.id === thisStudyId } );
			if ( study ) {
				let allCompSchedules = study.allCompSchedules;
				if ( allCompSchedules ) {
					if ( typeof allCompSchedules === 'string' || allCompSchedules instanceof String ) {
						allCompSchedules = JSON.parse(allCompSchedules);
					}
					this.setState({ currentSchedulePeriod: allCompSchedules[serviceType] });
				}
			}
		}

        if (this.state.create) {
            const record = JSON.parse(JSON.stringify(Records.empty12Lead));
			const recGeneral = record.record;
			let tzOffset = -utility.getTimeZoneOffset();
			if ( Math.abs(tzOffset) <= 16 ) {
				tzOffset *= 60;
			}
            recGeneral.timeZoneOffsetMinutes = tzOffset;
			recGeneral.recordDateTime = moment.tz(new Date(),'UTC').format("YYYY-MM-DDTHH:mm:ss");
			recGeneral.receiveDateTime = moment.tz(new Date(),'UTC').format("YYYY-MM-DDTHH:mm:ss");
            this.props.recordsDispatch.set(record);

			this.setState({
				timeZoneOffsetMinutes: tzOffset,
				crfQnA: this.getCrfQnA(),
				});
        }
        else {
            const recordId = this.state.recordId;
            const studyId = this.state.studyId;
            if (serviceType === Records.recordServiceTypes.event) {
                this.props.recordsDispatch.getEvent(recordId, studyId);
            }
            else if (serviceType === Records.recordServiceTypes.holter) {
                this.props.recordsDispatch.getHolter(recordId, studyId);
            }
            else {
                this.props.recordsDispatch.get12Lead(recordId, studyId);
            }
        }
    }

    handleCancel() {
        if (this.state.create) {
            this.props.history.goBack();
        }
        else {
            const recordId = this.state.recordId;
			const recordStateRecord = this.props.recordsState.record;
			const serviceType = recordStateRecord && recordStateRecord.record && recordStateRecord.record.serviceType;
            const studyId = this.state.studyId;

            if (serviceType === Records.recordServiceTypes.event) {
                this.props.recordsDispatch.getEvent(recordId, studyId);
            }
            else if (serviceType === Records.recordServiceTypes.holter) {
                this.props.recordsDispatch.getHolter(recordId, studyId);
            }
            else if (serviceType === Records.recordServiceTypes.twelveLead) {
                this.props.recordsDispatch.get12Lead(recordId, studyId);
            }
            if (this.state.editing) {
                this.setState({
                    editing: false
                });
            }
        }
    }

    handleEdit() {
        this.setState({
            editing: true
        });
    }

    handleKeyDown(e) {
        if (e.key === 'Enter') {
            this.handleSave();
        }
    }

    handleSave() {
        const create = this.state.create;
        const patientId = this.state.patientId;
        const recordStateRecord = this.props.recordsState.record;
		const serviceType = recordStateRecord && recordStateRecord.record && recordStateRecord.record.serviceType;

		if (recordStateRecord.record.isScheduled) {
			const allStudies = this.props.accountsState && this.props.accountsState.authenticatedAccount && this.props.accountsState.authenticatedAccount.studies;
			if (allStudies) {
				const thisStudyId = this.state.studyId;
				const study = allStudies.find(function (s) { return s.id === thisStudyId });
				if (study) {
					let allCompSchedules = study.allCompSchedules;
					if (allCompSchedules) {
						if (typeof allCompSchedules === 'string' || allCompSchedules instanceof String) {
							allCompSchedules = JSON.parse(allCompSchedules);
						}
						this.setState({ currentSchedulePeriod: allCompSchedules[serviceType] });
						recordStateRecord.record.schedulePeriod = allCompSchedules[serviceType];
					}
				}
			}
        }

        if (patientId === "" ||
            recordStateRecord.record.receiveDateTime == null ||
            recordStateRecord.record.recordDateTime == null
        ) {
            this.setState({
                error: true
            });
        }
        else {
            this.setState({
                error: false
            });

			const recGeneral = recordStateRecord.record;

			let tzOffset = this.state.timeZoneOffsetMinutes;
			if ( Math.abs(tzOffset) <= 16 ) {
				tzOffset *= 60;
			}
			recGeneral.timeZoneOffsetMinutes = tzOffset;

            (async () => {
                if (create) {
                    if (serviceType === Records.recordServiceTypes.holter) {
                        await this.props.recordsDispatch.createHolter(patientId);
                    }
                    else {
                        await this.props.recordsDispatch.create12Lead(patientId);
                    }
                }
                else {
                    if (serviceType === Records.recordServiceTypes.holter) {
                        await this.props.recordsDispatch.updateHolter();
                    }
                    else {
                        await this.props.recordsDispatch.update12Lead();
                    }
                }
            })().then(() => {
                this.props.recordsDispatch.setAll(null);
				this.props.recordsDispatch.setRefresh( true );
                this.props.history.push(paths.selectRecord);
            });
        }
    }

    handleServiceTypeChange(serviceType) {
        if (serviceType == null) {
            return;
        }

        const record = this.props.recordsState.record;
        record.record.serviceType = serviceType;
        this.props.recordsDispatch.set(record);
    }

	handleDropdownUsesScheduler( theChoice ) {
		this.setState({ isScheduler: (String(theChoice) === 'Yes') });
	}

	handleDropdownOrdinalNumber( theChoices ) {
		let theChoice = theChoices[0];
		this.setState({ currentScheduleOrdinal: theChoice });
        const recGeneral = this.props.recordsState.record.record;
		recGeneral.scheduleOrdinal = theChoice;
	}

	handleDropdownSuffix( theChoices ) {
		let theChoice = theChoices[0];
		this.setState({ currentScheduleSuffix: theChoice });
        const recGeneral = this.props.recordsState.record.record;
		recGeneral.scheduleSuffix = theChoice;
	}

	adjustVisibiltyOfQuestions() {
		const record = this.props.recordsState.record;
		if ( record === null || record === undefined ) {
			return;
		}
		const recGeneral = record.record;
		if ( recGeneral === null || recGeneral === undefined ) {
			return;
		}

		this.setState({ showAfibChildren: recGeneral.hasAfib });
		if ( ! recGeneral.hasAfib ) {
			/* event children */
			record.hasAfib30 = null;
			/* holter children */
			record.afibLongestDuration = null;
			/* 12-lead children */
			record.hasAfibContinuous = null;
		}

		this.setState({ showAflutterChildren: recGeneral.hasAflutter });
		if ( ! recGeneral.hasAflutter ) {
			/* event children */
			record.hasAflutter30 = null;
			/* holter children */
			record.aflutterLongestDuration = null;
			/* 12-lead children */
			record.hasAflutterContinuous = null;
		}

		this.setState({ showAtachyChildren: recGeneral.hasAtachy });
		if ( ! recGeneral.hasAtachy ) {
			/* event children */
			record.hasAtachy30 = null;
			/* holter children */
			record.atachyLongestDuration = null;
			/* 12-lead children */
			record.hasAtachyContinuous = null;
		}

		this.props.recordsDispatch.set(record);
	}

    handleYesNo(type,isTrue) {
        const record = this.props.recordsState.record;
        const recGeneral = record.record;

		switch ( type ) {

			case createRecordType.isMdNotification:
			case createRecordType.isAnalyzable:
				recGeneral[type] = isTrue;
				break;

			case createRecordType.hasAfib:
				this.setState({ showAfibChildren: isTrue });
				recGeneral[type] = isTrue;
				break;
			case createRecordType.hasAflutter:
				this.setState({ showAflutterChildren: isTrue });
				recGeneral[type] = isTrue;
				break;
			case createRecordType.hasAtachy:
				this.setState({ showAtachyChildren: isTrue });
				recGeneral[type] = isTrue;
				break;

			case createRecordType.hasAfib30:
			case createRecordType.hasAflutter30:
			case createRecordType.hasAtachy30:
			case createRecordType.hasAfibContinuous:
			case createRecordType.hasAflutterContinuous:
			case createRecordType.hasAtachyContinuous:
				record[type] = isTrue;
				break;

			default:
				break;
		}

		this.adjustVisibiltyOfQuestions();
		this.props.recordsDispatch.set(record);
		this.setState({ metadataEdited: true });
    }


    handleValue(value, type) {
        const record = this.props.recordsState.record;
        const recGeneral = record.record;

        switch (type) {
            case createRecordType.predominantRhythm:
                recGeneral[type] = value[0];
				break;

			case createRecordType.afibLongestDuration:
			case createRecordType.aflutterLongestDuration:
			case createRecordType.atachyLongestDuration:
			case createRecordType.analyzableDuration:
			case createRecordType.totalDuration:
				if ( /(\d\d*):(\d\d*):(\d\d*)/.test(value) ) {
					record[type] = value;
				} else {
					record[type] = value;
				}
				break;


            case createRecordType.comments:
                recGeneral.comments = value;
				break;
            case createRecordType.deviceModel:
                recGeneral.deviceModel = value;
                break;
            case createRecordType.deviceSerial:
                recGeneral.deviceSerial = value;
                break;
            case createRecordType.isMdOverreadRequired:
                recGeneral.isMdOverreadRequired = value;
                break;
            case createRecordType.isQaRequired:
                recGeneral.isQaRequired = value;
                break;
            case createRecordType.isScheduled:
                recGeneral.isScheduled = value;
                break;
            case createRecordType.isSymptomatic:
                recGeneral.isSymptomatic = value;
                break;
            case createRecordType.mdOverreadAssignedId:
                recGeneral.mdOverreadAssignedId = value;
                break;


            case createRecordType.receiveDateTime:
				{
				let tzOffset = this.state.timeZoneOffsetMinutes;
				// console.log(`handlevalue(${type}, ${value})  tzOffset = ${tzOffset} `);
				if ( Math.abs(tzOffset) <= 16 ) {
					tzOffset *= 60;
				}
				recGeneral.receiveDateTime = moment(value).subtract(tzOffset,'m').format("YYYY-MM-DDTHH:mm:ss");
				}
				break;

            case createRecordType.recordDateTime:
				{
				let tzOffset = this.state.timeZoneOffsetMinutes;
				// console.log(`handlevalue(${type}, ${value})  value = ${moment(value).format("YYYY-MM-DDTHH:mm:ss")}   rdt = ${moment(value).subtract(tzOffset,'m').format("YYYY-MM-DDTHH:mm:ss")} `);
				if ( Math.abs(tzOffset) <= 16 ) {
					tzOffset *= 60;
				}
				recGeneral.recordDateTime = moment(value).subtract(tzOffset,'m').format("YYYY-MM-DDTHH:mm:ss");
				}
				break;

            case createRecordType.timeZoneOffsetMinutes:
				if ( ! /^-?\d*$/.test(value) ) {
					break;
				}
				let tzOffset = value;
				if ( Math.abs(tzOffset) <= 16 ) {
					tzOffset *= 60;
				}
				this.setState({
					timeZoneOffsetMinutes: value,
				});
                recGeneral.timeZoneOffsetMinutes = 1 * value;
                break;


            case createRecordType.report:
                record.report = value;
                break;
            case createRecordType.serviceType:
                break;

            default:
                break;
        }

        this.props.recordsDispatch.set(record);
    }

	getCrfQnA() {
		const allStudies = this.props.accountsState && this.props.accountsState.authenticatedAccount && this.props.accountsState.authenticatedAccount.studies;

		var crfQnA;
		const myStudy = this.state.studyId;
		if ( allStudies ) {
			const thisStudy = allStudies.find( function (s) { return s.id === myStudy } );
			const serviceType = this.props.recordsState.record && this.props.recordsState.record.record && this.props.recordsState.record.record.serviceType;

			switch ( serviceType ) {
            	case Records.recordServiceTypes.event:
					crfQnA = thisStudy && thisStudy.crfQnaEvent;
					break;
            	case Records.recordServiceTypes.holter:
					crfQnA = thisStudy && thisStudy.crfQnaHolter;
					break;
            	case Records.recordServiceTypes.twelveLead:
					crfQnA = thisStudy && thisStudy.crfQna12Lead;
					break;
				default:
					break;
			}
		}

		if ( typeof crfQnA === 'string' || crfQnA instanceof String ) {
			crfQnA = JSON.parse(crfQnA);
		}
		return crfQnA;
	}

	PredominantRhythm = (props) => {
		const allRhythms = [
			"Unknown",
			"Accelerated Idioventricular Rhythm",
			"Accelerated Junctional Rhythm",
			"Asystole",
			"Atrial Fibrillation",
			"Atrial Flutter",
			"Atrial Tachycardia",
			"Idioventricular Rhythm",
			"Junctional Escape Rhythm",
			"Junctional Tachycardia",
			"Multifocal Atrial Tachycardia",
			"Normal Sinus Rhythm",
			"Paced Rhythm",
			"Pacemaker Failure to Capture",
			"Pacemaker Failure to Pace",
			"Pacemaker Single Chamber Atrial",
			"Premature Atrial Complex",
			"Second Degree Heart Block Type I",
			"Second Degree Heart Block Type II",
			"Sinus Arrhythmia",
			"Sinus Bradycardia",
			"Sinus Tachycardia",
			"Supraventricular Tachycardia",
			"Third Degree Heart Block",
			"Ventricular Fibrillation",
			"Ventricular Tachycardia",
			"Ventricular Tachycardia Monomorphic",
			"Ventricular Tachycardia Polymorphic",
			"Ventricular Tachycardia Torsade de Pointes",
			"Wandering Atrial Pacemaker",
			"Wolff-Parkinson-White Syndrome",
		];

		const classNameInput = "scheduler";

        const record = this.props.recordsState.record;
		if ( record === null ) {
			return null;
		}
        const recGeneral = record.record;

		//this has a tendency to carry with it the value from a previous usage
		//it should be unknown for the creation of a new record
		recGeneral.predominantRhythm = "Unknown";

		const accountsState = this.props.accountsState;
		const authenticatedRole = accountsState.authenticatedAccount.role;
        const isPhysicianRole = (authenticatedRole === Accounts.accountRoles.Physician);

		return (
			<div className="gap gap-bottom">
				Predominant Rhythm: 
				&nbsp;
				<DropdownSelection disabled={isPhysicianRole} id="dropdown_PredominantRhythm" isCheckboxes={false} className={classNameInput} values={[recGeneral.predominantRhythm]} selections={allRhythms} onSelect={(e) => this.handleValue(e, createRecordType.predominantRhythm)} />
			</div>
			);

	}

	HmInput = (props) => {
		return elements.getFormGroup(props.title, false, elements.getInput(props.name, props.disabled, (e) => this.handleValue(e.target.value, props.varname), this.handleKeyDown, elements.inputTypes.hm, props.value));
	};

	HmsInput = (props) => {
		return elements.getFormGroup(props.title, false, elements.getInput(props.name, props.disabled, (e) => this.handleValue(e.target.value, props.varname), this.handleKeyDown, elements.inputTypes.hms, props.value));
	};

	NumericInput = (props) => {
		return elements.getFormGroup(props.title, false, elements.getInput(props.name, props.disabled, (e) => this.handleValue(e.target.value, props.varname), this.handleKeyDown, elements.inputTypes.text, props.value));
	};

	Questions = (props) => {
        var record = this.props.recordsState.record;
		if ( record === null ) {
			return null;
		}
		const serviceType = record && record.record && record.record.serviceType;

		const isEvent = serviceType === Records.recordServiceTypes.event;
		const isHolter = serviceType === Records.recordServiceTypes.holter;
		const is12Lead = serviceType === Records.recordServiceTypes.twelveLead;

		return (
			<div>
			<BinaryRadio disabled={props.disabled} name="radio_MdNotification" onChangeFalse={this.handleYesNo.bind(this,createRecordType.isMdNotification,false)} onChangeTrue={this.handleYesNo.bind(this,createRecordType.isMdNotification,true)} title="MD Notification?" value={record.record.isMdNotification} />
			<BinaryRadio disabled={props.disabled} name="radio_Analyzable" onChangeFalse={this.handleYesNo.bind(this,createRecordType.isAnalyzable,false)} onChangeTrue={this.handleYesNo.bind(this,createRecordType.isAnalyzable,true)} title="Is the record analyzable?" value={record.record.isAnalyzable} />

			{isHolter && <this.HmInput disabled={props.disabled} name="radio_TotalDuration" varname={createRecordType.totalDuration} title="Total Duration: " value={record.totalDuration} /> }
			{isHolter && <this.HmInput disabled={props.disabled} name="radio_AnalyzableDuration" varname={createRecordType.analyzableDuration} title="Analyzable Duration: " value={record.analyzableDuration} /> }

			<BinaryRadio disabled={props.disabled} name="radio_Afib" onChangeFalse={this.handleYesNo.bind(this,createRecordType.hasAfib,false)} onChangeTrue={this.handleYesNo.bind(this,createRecordType.hasAfib,true)} title="Afib?" value={record.record.hasAfib} />

			{this.state.showAfibChildren &&
				<div className="indented" >
				{isEvent  && <BinaryRadio disabled={props.disabled} name="radio_hasAfib30" onChangeFalse={this.handleYesNo.bind(this,createRecordType.hasAfib30,false)} onChangeTrue={this.handleYesNo.bind(this,createRecordType.hasAfib30,true)} title="Has Afib of 30 seconds?" value={record.hasAfib30} /> }
				{isHolter && <this.HmsInput disabled={props.disabled} name="radio_AfibLongestDuration" varname={createRecordType.afibLongestDuration} title="Afib longest duration: " value={record.afibLongestDuration} /> }
				{is12Lead && <BinaryRadio disabled={props.disabled} name="radio_hasAfib30" onChangeFalse={this.handleYesNo.bind(this,createRecordType.hasAfibContinuous,false)} onChangeTrue={this.handleYesNo.bind(this,createRecordType.hasAfibContinuous,true)} title="Afib continuous?" value={record.hasAfibContinuous} /> }
				</div>
			}

			<BinaryRadio disabled={props.disabled} name="radio_Aflutter" onChangeFalse={this.handleYesNo.bind(this,createRecordType.hasAflutter,false)} onChangeTrue={this.handleYesNo.bind(this,createRecordType.hasAflutter,true)} title="Aflutter?" value={record.record.hasAflutter} />
			{this.state.showAflutterChildren &&
				<div className="indented" >
				{isEvent  && <BinaryRadio disabled={props.disabled} name="radio_hasAflutter30" onChangeFalse={this.handleYesNo.bind(this,createRecordType.hasAflutter30,false)} onChangeTrue={this.handleYesNo.bind(this,createRecordType.hasAflutter30,true)} title="Has Aflutter of 30 seconds?" value={record.hasAflutter30} /> }
				{isHolter && <this.HmsInput disabled={props.disabled} name="radio_AflutterLongestDuration" varname={createRecordType.aflutterLongestDuration} title="Aflutter longest duration: " value={record.aflutterLongestDuration} /> }
				{is12Lead && <BinaryRadio disabled={props.disabled} name="radio_hasafluttercon" onChangeFalse={this.handleYesNo.bind(this,createRecordType.hasAflutterContinuous,false)} onChangeTrue={this.handleYesNo.bind(this,createRecordType.hasAflutterContinuous,true)} title="Aflutter continuous?" value={record.hasAflutterContinuous} /> }
				</div>
			}

			<BinaryRadio disabled={props.disabled} name="radio_Atachy" onChangeFalse={this.handleYesNo.bind(this,createRecordType.hasAtachy,false)} onChangeTrue={this.handleYesNo.bind(this,createRecordType.hasAtachy,true)} title="Atachy?" value={record.record.hasAtachy} />
			{this.state.showAtachyChildren &&
				<div className="indented" >
				{isEvent  && <BinaryRadio disabled={props.disabled} name="radio_hasAtachy30" onChangeFalse={this.handleYesNo.bind(this,createRecordType.hasAtachy30,false)} onChangeTrue={this.handleYesNo.bind(this,createRecordType.hasAtachy30,true)} title="Has Atachy of 30 seconds?" value={record.hasAtachy30} /> }
				{isHolter && <this.HmsInput disabled={props.disabled} name="radio_atachyLongestDuration" varname={createRecordType.atachyLongestDuration} title="Atachy longest duration: " value={record.atachyLongestDuration} /> }
				{is12Lead && <BinaryRadio disabled={props.disabled} name="radio_hasAtachyCont" onChangeFalse={this.handleYesNo.bind(this,createRecordType.hasAtachyContinuous,false)} onChangeTrue={this.handleYesNo.bind(this,createRecordType.hasAtachyContinuous,true)} title="Atachy continuous?" value={record.hasAtachyContinuous} /> }
				</div>
			}
			</div>
		);
	}

	Comments = (props) => {
		/* Editable by Admin & Tech roles.
		   Editable when record is not qa'd yet (so record is not final, so status is < 30)
		   */
		const accountsState = this.props.accountsState;
		const authenticatedRole = accountsState.authenticatedAccount.role;
		const isAdministratorRole = authenticatedRole === Accounts.accountRoles.Administrator;
		const isTechnicianRole = authenticatedRole === Accounts.accountRoles.Technician;
		const disabled = (
				(!isAdministratorRole && !isTechnicianRole)
				);
		const record = this.props.recordsState.record;
		if ( record === null ) {
			return null;
		}
		const recGeneral = record.record;

		if ( recGeneral.comments === null || recGeneral.comments === undefined ) {
			recGeneral.comments = '';
		}

		return (
			<div className="scheduler-box">
                Comments<i><small> - Optional</small></i>
				<Input className="input" onChange={(e) => this.handleValue(e.target.value, createRecordType.comments)} disabled={disabled} id="comments" type="textarea" value={recGeneral.comments} />
			</div>
			);
	};


    render() {
        if (!Accounts.authenticatedHcsRole(this.props.accountsState)) {
            return (
                <NotAuthenticated />
            );
        }

        const cancel = "Cancel";
        var deviceModel = null;
        var deviceSerial = null;
        var displayEditLink = false;
        const editing = this.state.editing;
        const fileInput = "fileInput";
        var isEvent = false;
        var isHolter = false;
        var isMdOverreadRequired = null;
        var isQaRequired = null;
        var isScheduled = null;
        var isSymptomatic = null;
        var is12Lead = false;
        var mdOverreadAssignedDisabled = true;
        var patientCode = this.state.patientCode;
        var receiveDateTime = null;
        var record = this.props.recordsState.record;
        var recordDateTime = null;
        const save = "Save";
        var timeZoneOffsetMinutes = null;
        var title = "Create Record";
        var uploadInput = null;
        var uploadInputId = "uploadInput";
        var uploadInputDisplay = false;
        const uploadTitle = "Upload";

        if (!this.state.create) {
            if (this.state.editing) {
                title = "Edit Record";
            }
            else {
                displayEditLink = true;
                title = "Record";
            }
        }

        if (record != null && record.record != null) {
            var fileName = null;
            const recGeneral = record.record;
            const serviceType = recGeneral.serviceType;

            isEvent = serviceType === Records.recordServiceTypes.event;
            isHolter = serviceType === Records.recordServiceTypes.holter;
            is12Lead = serviceType === Records.recordServiceTypes.twelveLead;

            if (recGeneral.patient != null &&
                recGeneral.patient.code != null) {
                patientCode = recGeneral.patient.code;
            }
            if (recGeneral.isMdOverreadRequired != null) {
                mdOverreadAssignedDisabled = (
                    !recGeneral.isMdOverreadRequired ||
                    !editing
                );
            }
            if (record.report != null) {
                fileName = record.report.name;
            }

			let tzOffset = this.state.timeZoneOffsetMinutes;
			if ( Math.abs(tzOffset) <= 16 ) {
				tzOffset *= 60;
			}

			const recordDateTimePicker = (val,type) => {

				if ( ! moment(val).isValid() ) {
					val = moment.tz(new Date(),'UTC').format("YYYY-MM-DDTHH:mm:ss");
				}
				return (
						<DatePicker
							selected={new Date(moment(val).add(tzOffset,'m').format())}
							onChange={(datestr) => this.handleValue(datestr, type)}
							timeInputLabel="Time:"
							dateFormat="MM/dd/yyyy HH:mm:ss"
							timeFormat="HH:mm:ss"
							placeholderText="Type or Click to select a date"
							showTimeInput
							peekNextMonth
							showMonthDropdown
							showYearDropdown
							dropdownMode="select"
							closeOnScroll={true}
						/>
				);
			};


            deviceModel = elements.getFormGroup("Device Model", true, elements.getInput("deviceModelInput", !editing, (e) => this.handleValue( e.target.value, createRecordType.deviceModel), this.handleKeyDown, elements.inputTypes.text, recGeneral.deviceModel));
			deviceSerial = elements.getFormGroup("Device Serial Number", true, elements.getInput("deviceSerialInput", !editing, (e) => this.handleValue(e.target.value, createRecordType.deviceSerial), this.handleKeyDown, elements.inputTypes.text, recGeneral.deviceSerial));
            isMdOverreadRequired = <BinaryRadio hideNotAnswered name="isMdOverreadRequiredRadio" onChangeFalse={() => this.handleValue( false, createRecordType.isMdOverreadRequired)} onChangeTrue={() => this.handleValue( true, createRecordType.isMdOverreadRequired)} title="Is MD overread required?" value={recGeneral.isMdOverreadRequired} />;
			isQaRequired = <BinaryRadio disabled hideNotAnswered name="isQaRequiredRadio" onChangeFalse={() => this.handleValue(false, createRecordType.isQaRequired)} onChangeTrue={() => this.handleValue(true, createRecordType.isQaRequired)} title="Is quality assurance (QA) required?" value={recGeneral.isQaRequired} />;
            isScheduled = <BinaryRadio disabled={!editing} name="scheduledRadio" onChangeFalse={() => this.handleValue( false, createRecordType.isScheduled)} onChangeTrue={() => this.handleValue( true, createRecordType.isScheduled)} title="Is the record scheduled?" value={recGeneral.isScheduled} />;
            isSymptomatic = <BinaryRadio disabled={!editing} name="symptomaticRadio" onChangeFalse={() => this.handleValue( false, createRecordType.isSymptomatic)} onChangeTrue={() => this.handleValue( true, createRecordType.isSymptomatic)} title="Is the record symptomatic?" value={recGeneral.isSymptomatic} />;
			receiveDateTime = elements.getFormGroup(`Receive DateTime (Patient's Time)`, false, recordDateTimePicker(recGeneral.receiveDateTime,createRecordType.receiveDateTime), null );
			recordDateTime = elements.getFormGroup(`Record DateTime (Patient's Time)`, false, recordDateTimePicker(recGeneral.recordDateTime,createRecordType.recordDateTime), null );
			timeZoneOffsetMinutes = elements.getFormGroup("Time Zone Offset (difference between UTC and local time)", true, elements.getInputGroup(elements.getInput("timeZoneOffsetMinutesInput", !editing, (e) => this.handleValue( e.target.value, createRecordType.timeZoneOffsetMinutes), this.handleKeyDown, elements.inputTypes.text, this.state.timeZoneOffsetMinutes), ((Math.abs(this.state.timeZoneOffsetMinutes) <= 16) || isNaN(this.state.timeZoneOffsetMinutes)) ? "Hours" : "Minutes"));
            uploadInput = elements.getInput(uploadInputId, true, null, this.handleKeyDown, elements.inputTypes.text, fileName);
            uploadInputDisplay = fileName != null;
        }

        if (patientCode === "") {
            patientCode = "{empty}";
        }
        
        const serviceTypeName = "serviceTypeRadio";
        const eventRadio = elements.getRadioInput(serviceTypeName, isEvent, true, null, null, "Event");
        const holterRadio = elements.getRadioInput(serviceTypeName, isHolter, false, this.handleServiceTypeChange.bind(this, Records.recordServiceTypes.holter), null, "Holter");
        const twelveLeadRadio = elements.getRadioInput(serviceTypeName, is12Lead, false, this.handleServiceTypeChange.bind(this, Records.recordServiceTypes.twelveLead), null, "12-Lead");
        const serviceTypeRadio = elements.getRadioFormGroup("Service Type", false, eventRadio, holterRadio, twelveLeadRadio);

		const ScheduleDiv = (props) => {
			if ( ! props.value ) {
				return null;
			}
			const classNameInput = "scheduler";
			let arrOrdinalNumbers = (Array.from( Array(52), (_, x) => x + 1 )).map( (n) => utility.ordinalSuffixOf(n).toUpperCase() );
			arrOrdinalNumbers.unshift(blankDropdown);

			let arrSuffix = [blankDropdown, 'BASELINE', 'DISCHARGE', 'POST PROCEDURE', 'PRE PROCEDURE'];

			return (
				<div className="gap-bottom">
					Scheduled: 
					&nbsp;
					<DropdownSelection id="dropdown_OrdinalNumbers" isCheckboxes={false} className={classNameInput} values={[this.state.currentScheduleOrdinal]} selections={arrOrdinalNumbers} onSelect={this.handleDropdownOrdinalNumber.bind(this)} />
					&nbsp;
					<div className="boxPeriod">
					of {this.state.currentSchedulePeriod}
					</div>
					&nbsp;
					<DropdownSelection id="dropdown_Suffix" isCheckboxes={false} className={classNameInput} values={[this.state.currentScheduleSuffix]} selections={arrSuffix} onSelect={this.handleDropdownSuffix.bind(this)} />
				</div>
				);
		};

		return (
            <div>
                <h1>{title}<small> for patient code '{patientCode}' </small>{displayEditLink && <Button className="button-link" onClick={this.handleEdit}>(Edit)</Button>}</h1>
                {this.state.error && <Alert color="warning">Missing or incorrect fields.</Alert>}
                {serviceTypeRadio}
                {recordDateTime}
                {receiveDateTime}
                {timeZoneOffsetMinutes}
                {deviceModel}
                {deviceSerial}
                <this.Comments />
                <hr />
                {isScheduled}
                <ScheduleDiv value={record && record.record && record.record.isScheduled} />
                {isSymptomatic}
				<this.PredominantRhythm />
				<this.Questions />
                <hr />
                {isMdOverreadRequired}
                <MdOverreadAssigned createRecord disabled={mdOverreadAssignedDisabled} />
                <hr />
                {isQaRequired}
				{isHolter && <CreateRecordCrfQa studyId={this.props.studyId} create={this.state.create} disabled={!editing} handleKeyDown={this.handleKeyDown} serviceType={Records.recordServiceTypes.holter} />}
				{isEvent && <CreateRecordCrfQa studyId={this.props.studyId} create={this.state.create} disabled={!editing} handleKeyDown={this.handleKeyDown} serviceType={Records.recordServiceTypes.event} />}
				{is12Lead && <CreateRecordCrfQa studyId={this.props.studyId} create={this.state.create} disabled={!editing} handleKeyDown={this.handleKeyDown} serviceType={Records.recordServiceTypes.twelveLead} />}
                <FormGroup>
                    <Label for={uploadInputId}>Report<i><small> - Optional</small></i></Label>
                    {uploadInputDisplay
                        ?
                        <InputGroup>
                            {uploadInput}
                            <InputGroupAddon addonType="append">
                                <Button aria-label="Close" className="button" close="true" disabled={!editing} onClick={() => this.handleValue( null, createRecordType.report)} outline>
                                    <span aria-hidden="true">&times;</span>
                                </Button>
                            </InputGroupAddon>
                        </InputGroup>
                        :
                        <InputGroup>
                            <Input disabled={!editing} hidden id={fileInput} onChange={this.upload.bind(this, fileInput)} type="file" /><Label className="file-upload" for={fileInput} title={uploadTitle}>{uploadTitle}</Label>
                        </InputGroup>
                    }
                </FormGroup>
                {isEvent && <CreateRecordEvent disabled={!editing} handleKeyDown={this.handleKeyDown} />}
                {isHolter && <CreateRecordHolter disabled={!editing} handleKeyDown={this.handleKeyDown} />}
                {is12Lead && <CreateRecord12Lead disabled={!editing} handleKeyDown={this.handleKeyDown} />}
                {editing && (
                    <div className="button-gap">
                        <Button className="button" onClick={this.handleSave} title={save}>{save}</Button>{' '}
                        <Button className="button" onClick={this.handleCancel} title={cancel}>{cancel}</Button>
                    </div>
                )}
            </div>
        );
    }

    upload(inputId) {
        var file = null;
        const input = document.getElementById(inputId);
        if (input != null &&
            input.files != null &&
            input.files.length === 1) {
            file = input.files[0];
        }

        if (file != null) {
            this.handleValue( file, createRecordType.report);
        }
        input.value = null;
    }
}

const CreateRecordConnect = withRouter(connect(
    state => ({
        accountsState: state.accounts,
        recordsState: state.records
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        recordsDispatch: bindActionCreators(Records.actionCreators, dispatch)
    })
)(CreateRecordInternal));

export default class CreateRecord extends React.Component {
    render() {
        var create = true;
        var editing = true;
        var patientCode = "";
        var patientId = "";
        var recordId = "";
        var serviceType = Records.recordServiceTypes.twelveLead;
        var studyId = "";
        var crfQnA = [];

        const propsState = this.props.location.state;
        if (propsState != null) {
            create = utility.propCheck(propsState.create, create);
            editing = utility.propCheck(propsState.editing, editing);
            patientCode = utility.propCheck(propsState.patientCode, patientCode);
            patientId = utility.propCheck(propsState.patientId, patientId);
            recordId = utility.propCheck(propsState.recordId, recordId);
            serviceType = utility.propCheck(propsState.serviceType, serviceType);
            studyId = utility.propCheck(propsState.studyId, studyId);
			crfQnA = utility.propCheck(propsState.crfQnA, crfQnA)
        }

        return (
            <ErrorBoundary>
                <CreateRecordConnect create={create} editing={editing} patientCode={patientCode} patientId={patientId} recordId={recordId} serviceType={serviceType} studyId={studyId} crfQnA={crfQnA} />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CreateRecord.js